import type { ReactNode } from 'react';

/**
 * Một **khối có tiêu đề**: thẻ bo 12px, hàng tiêu đề ngăn bằng viền trong, nội
 * dung padding 20px, và chỗ cho một nút ở góc phải.
 *
 * Có để mọi mục của trang chi tiết kênh trông như nhau. Sau khi 9 tab gộp còn
 * 5, mỗi tab chứa 2–4 mục do **module khác nhau** dựng; nếu mỗi module tự vẽ
 * hàng tiêu đề thì cùng một trang có bốn cỡ chữ tiêu đề và bốn khoảng padding.
 *
 * `id` thành neo `#muc-<id>`: link cũ `?tab=dong-bo` nhảy đúng chỗ trong trang
 * mới (xem `tabRegistry.TAB_CU_SANG_NHOM`).
 */
export interface KhoiMucProps {
  id?: string;
  tieuDe: string;
  moTa?: string;
  /** Nút / trạng thái ở góc phải tiêu đề. */
  phai?: ReactNode;
  /** Bỏ padding của thân — dùng khi thân là một bảng chiếm trọn khối. */
  satLe?: boolean;
  children: ReactNode;
}

export function KhoiMuc({ id, tieuDe, moTa, phai, satLe = false, children }: KhoiMucProps) {
  return (
    <section
      {...(id === undefined ? {} : { id: `muc-${id}` })}
      className="overflow-hidden rounded-the border border-vien bg-be-mat"
    >
      <div className="flex flex-wrap items-start justify-between gap-3 border-b border-vien-trong px-5 py-3.5">
        <div className="min-w-0">
          <h3 className="text-tieu-de-khoi font-semibold text-chu">{tieuDe}</h3>
          {moTa !== undefined && <p className="mt-0.5 text-phu text-chu-phu">{moTa}</p>}
        </div>
        {phai !== undefined && <div className="shrink-0">{phai}</div>}
      </div>

      {/* Bảng chiếm trọn khối thì bỏ viền riêng của `DataTable`: viền kép lộ ngay ở khổ hẹp. */}
      <div className={satLe ? '[&>div]:rounded-none [&>div]:border-0' : 'p-5'}>{children}</div>
    </section>
  );
}
